import { Controller } from "@hotwired/stimulus"

// Show sections matching the selected pill; an empty key (All) shows every section.
// Use Stimulus targets to keep separate and nested filters independent.
export default class extends Controller {
  static targets = ["pill", "section"]

  select(event) {
    const key = event.params.key?.toString() ?? ""

    this.pillTargets.forEach((pill) => {
      const active = pill === event.currentTarget
      pill.classList.toggle("active", active)
      pill.setAttribute("aria-pressed", active)
    })

    this.sectionTargets.forEach((section) => {
      section.hidden = key !== "" && section.dataset.pillFilterKey !== key
    })
  }
}
